export default __webpack_public_path__ + "static/media/twitter.f9bcd80a.svg";